import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ComposerNavComponent } from './composer-nav.component';

@NgModule({
  declarations: [ComposerNavComponent],
  imports: [CommonModule, RouterModule],
  exports: [ComposerNavComponent]
})
export class ComposerNavModule {}
